import type { VennColors } from 'venn-ui-kit';

export const getColumnColors = (colors: VennColors) => [
  colors.DataLineColor.Gold,
  colors.DataLineColor.Pink,
  colors.DataLineColor.DarkBlue,
  colors.DataLineColor.PaleGold,
  colors.DataLineColor.PaleBlue,
  colors.DataLineColor.Green,
  colors.DataLineColor.Yellow,
];
